export const ROUTES = {
  HOME: "/",
  HOME_WITH_PARAMS: "/project/:projectId/milestone/:milestoneId",
  LOGIN: "/login",
  AUTHORIZE_REDIRECT: "/authorize-redirect",
  USER_PROJECT_ACCESSES: "/user-access-to-projects",
  EMAIL_CONFIRMATION: "/email-confirmation",
  EMAIL_CONFIRMED: "/email-confirmed",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  SYNC_DASHBOARD: "/sync-dashboard",
  HOURS_DASHBOARD: "/hours-dashboard",
  MILESTONE_HEALTH_REPORT: "/admin/milestone-health-report",
};
